import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2FeatureDialogProperties extends BasicDialogProperties {
    public featureId: number = 0;

    constructor(featureId: number) {
        super();

        this.featureId = featureId;
    }
}
